import { render } from "./SwipeActionsContainer.vue?vue&type=template&id=476861bf&scoped=true"
import script from "./SwipeActionsContainer.vue?vue&type=script&lang=js"
export * from "./SwipeActionsContainer.vue?vue&type=script&lang=js"

import "./SwipeActionsContainer.vue?vue&type=style&index=0&id=476861bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476861bf"]])

export default __exports__